/* Presentation enhancements only. Product/cart requests remain with Impact/Yampi. */
(() => {
  if (!document.documentElement.classList.contains('pallacio-editorial')) return;
  const key = 'pallacio:wishlist:v1';
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21 3.6 12.8a5.2 5.2 0 0 1 7.4-7.4L12 6.5l1-1.1a5.2 5.2 0 0 1 7.4 7.4Z"/></svg>';
  const read = () => { try { const items = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(items) ? items.filter(x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x)) : []; } catch { return []; } };
  const write = (items) => { try { localStorage.setItem(key, JSON.stringify(items)); } catch {} syncHearts(); };
  function syncHearts() {
    const saved = read();
    document.querySelectorAll('[data-pallacio-save]').forEach(button => {
      const active = saved.includes(button.dataset.pallacioSave);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Salvar nos favoritos');
    });
  }
  function enhance(root = document) {
    root.querySelectorAll('.product-info > .pallacio-product-utilities').forEach(utilities => utilities.remove());
    root.querySelectorAll('.pallacio-product-accordions > details[data-pallacio-drawer]').forEach(details => {
      const trigger = details.previousElementSibling?.classList.contains('pallacio-info-trigger') ? details.previousElementSibling : null;
      const drawer = details.nextElementSibling?.classList.contains('pallacio-info-drawer') ? details.nextElementSibling : null;
      const content = drawer?.querySelector('.pallacio-product-accordion__content');
      if (content) details.append(content);
      trigger?.remove();
      drawer?.remove();
      details.hidden = false;
      delete details.dataset.pallacioDrawer;
    });
    root.querySelectorAll('.product-card,.pallacio-product-card,.pallacio-tab-card').forEach(card => {
      const colors = card.querySelector('.pallacio-product-card__colors,.pallacio-tab-card__colors');
      const destination = card.querySelector('.pallacio-product-card__below-price,.pallacio-tab-card__below-price');
      if (!card.hasAttribute('data-pallacio-home-synced') && colors && destination && colors.parentElement !== destination) destination.append(colors);
      if (card.querySelector('[data-pallacio-save]')) return;
      const link = card.querySelector('a[href*="/products/"]');
      const handle = link?.pathname.match(/\/products\/([^/?]+)/)?.[1];
      if (!handle || !/^[a-z0-9-]+$/.test(handle)) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'pallacio-card-heart';
      button.dataset.pallacioSave = handle; button.innerHTML = heart;
      card.append(button);
    });
    root.querySelectorAll('.button,.pallacio-tabs__view-all,.pallacio-collection-more__button').forEach(button => {
      if (button.childElementCount || !button.textContent.trim()) return;
      const label = document.createElement('span'); label.className = 'pallacio-roll';
      label.textContent = button.textContent; button.replaceChildren(label);
    });
    syncHearts();
  }
  let wishlistRequest = 0;
  async function renderWishlist() {
    const drawer = document.getElementById('pallacio-wishlist');
    if (!drawer) return;
    const request = ++wishlistRequest;
    const list = drawer.querySelector('[data-pallacio-wishlist-items]');
    const empty = drawer.querySelector('[data-pallacio-wishlist-empty]');
    const error = drawer.querySelector('[data-pallacio-wishlist-error]');
    const handles = read(); list.replaceChildren(); empty.hidden = handles.length > 0; error.hidden = true;
    const base = window.Shopify?.routes?.root || '/';
    const results = await Promise.allSettled(handles.map(async handle => {
      const response = await fetch(`${base}products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) throw new Error('Unavailable product');
      return { handle, product: await response.json() };
    }));
    if (request !== wishlistRequest) return;
    for (const result of results) {
      if (result.status !== 'fulfilled') { error.hidden = false; continue; }
      const { handle, product } = result.value;
      const item = document.createElement('article'); item.className = 'pallacio-wishlist__item';
      const link = document.createElement('a'); link.href = `${base}products/${encodeURIComponent(handle)}`;
      const image = document.createElement('img'); image.src = product.featured_image || ''; image.alt = product.title; image.loading = 'lazy'; image.width = 300; image.height = 375;
      const title = document.createElement('p'); title.textContent = product.title;
      link.append(image,title);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remover'; remove.dataset.pallacioRemove = handle;
      item.append(link,remove); list.append(item);
    }
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-pallacio-save]');
    if (save) { event.preventDefault(); const items = read(); const handle = save.dataset.pallacioSave; write(items.includes(handle) ? items.filter(x => x !== handle) : [...items,handle]); }
    const remove = event.target.closest('[data-pallacio-remove]');
    if (remove) { write(read().filter(x => x !== remove.dataset.pallacioRemove)); renderWishlist(); }
  });
  document.addEventListener('dialog:before-show', event => { if (event.target.id === 'pallacio-wishlist') renderWishlist(); });
  // Also work with the older Impact dialog lifecycle used by this theme.
  document.addEventListener('click', event => { if (event.target.closest('[aria-controls="pallacio-wishlist"]')) renderWishlist(); });
  document.addEventListener('change', event => {
    const drawer = event.target.closest('.pallacio-variant-drawer');
    if (!drawer || !event.target.matches('input[data-option-position]')) return;
    // Inputs stay in their original fieldset and retain form association.
    const fieldset = drawer.closest('fieldset');
    const selected = fieldset?.querySelector('[data-pallacio-selected-option]');
    const label = fieldset?.querySelector(`label[for="${CSS.escape(event.target.id)}"]`);
    if (selected && label) selected.textContent = label.getAttribute('title') || label.textContent.trim();
    drawer.hide?.();
  });
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  window.addEventListener('storage', event => { if (event.key === key) syncHearts(); });
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (scheduled || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.matches('.pallacio-card-heart,.pallacio-roll')))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  });
  observer.observe(document.getElementById('main') || document.body,{childList:true,subtree:true});
  enhance();
  matchMedia('(min-width:1280px)').addEventListener('change', () => {
    document.querySelectorAll('[data-pallacio-cascade]').forEach(drawer => drawer.reinitializeDrawer?.());
  });
})();
